'use strict';

(function () {
  if (typeof document !== 'undefined') {
    var head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style'),
        css = ".thumb:hover .ytp-large-play-button-bg[data-v-607d053d] { transition: fill 0.1s cubic-bezier(0, 0, 0.2, 1), fill-opacity 0.1s cubic-bezier(0, 0, 0.2, 1); fill: #f00; fill-opacity: 1; } ";style.type = 'text/css';if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }head.appendChild(style);
  }
})();

var embedUrlBase = 'https://www.youtube.com/embed';
var thumbUrlBase = 'https://i.ytimg.com/vi';

var YoutubeEmbedLite = { render: function () {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', [_c('div', { style: _vm.wrapperStyle }, [!_vm.isClicked ? _c('div', { staticClass: "thumb", style: _vm.thumbStyle, on: { "click": function ($event) {
          _vm.isClicked = true;
        } } }, [_c('button', { staticStyle: { "position": "absolute", "left": "50%", "top": "50%", "width": "68px", "height": "48px", "transform": "translate(-50%, -50%)", "transition": "opacity 0.25s cubic-bezier(0, 0, 0.2, 1)", "z-index": "63", "border": "none", "background-color": "transparent", "padding": "0", "font-size": "100%", "cursor": "inherit", "outline": "0" }, attrs: { "aria-label": "play" } }, [_c('svg', { attrs: { "height": "100%", "version": "1.1", "viewBox": "0 0 68 48", "width": "100%" } }, [_c('path', { staticClass: "ytp-large-play-button-bg", attrs: { "d": "M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z", "fill": "#212121", "fill-opacity": "0.8" } }), _vm._v(" "), _c('path', { attrs: { "d": "M 45,24 27,14 27,34", "fill": "#fff" } })])])]) : _c('iframe', { style: _vm.contentStyle, attrs: { "src": _vm.src, "frameborder": "0", "allow": "autoplay; encrypted-media", "allowfullscreen": "" } })])]);
  }, staticRenderFns: [], _scopeId: 'data-v-607d053d',
  name: 'YoutubeEmbedLite',
  props: {
    aspect: { type: Number, default: 9 / 16 },
    vid: { type: String, required: true },
    thumbQuality: { type: String, default: 'mq' },
    params: { type: Object, default: function () {} }
  },
  data: function data() {
    return {
      isClicked: false
    };
  },
  computed: {
    contentStyle: function contentStyle() {
      return {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%'
      };
    },
    wrapperStyle: function wrapperStyle() {
      return {
        width: '100%',
        height: '0px',
        position: 'relative',
        'padding-bottom': ((this.aspect * 100) + "%")
      };
    },
    src: function src() {
      var autoplayParams = Object.assign({}, this.params, { autoplay: 1 });
      var query = Object.keys(autoplayParams).reduce(function (prev, curr) { return prev.concat( [[curr, autoplayParams[curr]].join('=')]); }, []).join('&');
      return [[embedUrlBase, this.vid].join('/'), query].join('?');
    },
    thumbUrl: function thumbUrl() {
      return [thumbUrlBase, this.vid, ((this.thumbQuality) + "default.jpg")].join('/');
    },
    thumbStyle: function thumbStyle() {
      return Object.assign({}, this.contentStyle, {
        background: 'rgba(0, 0, 0, 0.6) no-repeat center center',
        'background-size': 'cover',
        cursor: 'pointer',
        overflow: 'hidden',
        display: 'inline-block',
        'background-image': ("url(" + (this.thumbUrl) + ")")
      });
    }
  }
};

module.exports = YoutubeEmbedLite;
